/**
 * Scene reconciler config.
 */
export type SceneReconcilerConfig = {
  // hideAvatar: boolean;
  // hideBackground: boolean;
  // hideGarmentHems: boolean;
  // hideGarmentPieces: boolean;
  // hideGarmentSeams: boolean;
  // hideGround: boolean;
  // hideLogos: boolean;
  hideStitches: boolean;
  // useGarmentGeometry: boolean;
  useStitchesDecals: boolean;
};

/**
 * Create scene reconciler config.
 */
export const create = (() => {
  const ConfigDef: SceneReconcilerConfig = {
    // hideAvatar: true,
    // hideBackground: true,
    // hideGarmentHems: false,
    // hideGarmentPieces: false,
    // hideGarmentSeams: false,
    // hideGround: true,
    // hideLogos: false,
    hideStitches: false,
    // useGarmentGeometry: true,
    useStitchesDecals: true,
  };

  return (config: Partial<SceneReconcilerConfig> = {}) => {
    const all = { ...ConfigDef, ...config };
    return all;
  };
})();
